import { render, staticRenderFns } from "./defineTable.vue?vue&type=template&id=43d21a96&scoped=true&"
import script from "./defineTable.vue?vue&type=script&lang=js&"
export * from "./defineTable.vue?vue&type=script&lang=js&"
import style0 from "./defineTable.vue?vue&type=style&index=0&id=43d21a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d21a96",
  null
  
)

export default component.exports